import FilterTime from "./FilterTime";
import ImageIcon from "./ImageIcon";
import MultipleSelect from "./Multiple";
import NoData from "./NoData";
import Pagination from "./Pagination";
import RouterLink from "./RouterLink";
import SearchText from "./SearchText";
import TextCopy from "./TextCopy";
import ProgrammingLanguage from "./ProgrammingLanguage";

const itemsComponents = {
  FilterTime,
  ImageIcon,
  MultipleSelect,
  NoData,
  Pagination,
  RouterLink,
  SearchText,
  TextCopy,
  ProgrammingLanguage
}

export default itemsComponents;